module.exports = __webpack_public_path__ + "h5/img/offer_2026.41f812a0.png";